import React, { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import Header from '../../components/Header';
import './Precatorios.css';

const Precatorios = () => {
  const navigate = useNavigate();
  const [activeFAQ, setActiveFAQ] = useState(null);

  const handleCTAClick = () => {
    navigate('/registro');
  };

  const toggleFAQ = (index) => {
    setActiveFAQ(activeFAQ === index ? null : index);
  };

  const faqs = [
    {
      question: "O que são precatórios?",
      answer: "Precatórios são requisições de pagamento expedidas pelo Poder Judiciário para que entes públicos (União, Estados, Municípios) paguem dívidas reconhecidas por sentença judicial transitada em julgado."
    },
    {
      question: "Quanto tempo leva para receber um precatório?",
      answer: "O prazo varia conforme o estado e tipo de precatório, podendo levar de 5 a 15 anos ou mais. Por isso, muitos credores preferem vender seus precatórios para receber o valor de forma antecipada."
    },
    {
      question: "É seguro vender meu precatório?",
      answer: "Sim! A venda de precatórios é 100% legal e regulamentada. Na MICA Capital, todos os processos seguem rigorosos padrões jurídicos e de segurança."
    },
    {
      question: "Qual o valor que vou receber?",
      answer: "O valor depende de diversos fatores como prazo de pagamento, estado emissor, valor do precatório e condições de mercado. Nossa IA calcula o valor justo em minutos e você recebe uma proposta transparente."
    },
    {
      question: "Quanto tempo leva para receber o dinheiro após a venda?",
      answer: "Na MICA Capital, com nossa tecnologia de IA, você recebe o dinheiro em até 5 dias após a validação dos documentos e assinatura do contrato."
    },
    {
      question: "Posso vender parte do meu precatório?",
      answer: "Sim! É possível vender parcialmente seu precatório, mantendo parte do valor para receber futuramente."
    }
  ];

  return (
    <div className="precatorios-page">
      <Header />

      <main className="main-content">
        {/* Hero Section */}
        <section className="hero-section precatorios-hero">
          <div className="hero-background">
            <div className="container">
              <div className="hero-content">
                <div className="hero-badge">
                  <svg width="24" height="24" viewBox="0 0 24 24" fill="currentColor">
                    <path d="M14 2H6c-1.1 0-1.99.9-1.99 2L4 20c0 1.1.89 2 1.99 2H18c1.1 0 2-.9 2-2V8l-6-6zm2 16H8v-2h8v2zm0-4H8v-2h8v2zm-3-5V3.5L18.5 9H13z"/>
                  </svg>
                  Guia Completo
                </div>

                <h1 className="hero-title">
                  Entenda Tudo Sobre<br />
                  <span className="highlight-text">Precatórios</span>
                </h1>

                <p className="hero-subtitle">
                  Aprenda como funcionam os precatórios, os tipos existentes e por que vender seu precatório pode ser a melhor decisão financeira.
                </p>
              </div>
            </div>
          </div>
        </section>

        {/* What Are Precatorios Section */}
        <section className="what-are-section">
          <div className="container">
            <div className="section-header">
              <h2 className="section-title">O Que São Precatórios?</h2>
            </div>

            <div className="what-are-content">
              <div className="what-are-text">
                <p className="lead-text">
                  Precatórios são ordens de pagamento emitidas pela Justiça para que o poder público (União, Estados ou Municípios) pague dívidas reconhecidas judicialmente.
                </p>
                <p>
                  Quando você ganha uma ação contra o governo, o juiz determina que o ente público deve pagar. Como não é possível penhorar bens públicos, o pagamento é feito através do sistema de precatórios.
                </p>
                <p>
                  O processo envolve várias etapas burocráticas e pode levar anos. Por isso, muitas pessoas optam por vender seus precatórios e receber o valor de forma antecipada.
                </p>
              </div>

              <div className="what-are-illustration">
                <div className="illustration-card">
                  <div className="illustration-icon">
                    <svg width="80" height="80" viewBox="0 0 24 24" fill="currentColor">
                      <path d="M12 2C6.48 2 2 6.48 2 12s4.48 10 10 10 10-4.48 10-10S17.52 2 12 2zm-2 15l-5-5 1.41-1.41L10 14.17l7.59-7.59L19 8l-9 9z"/>
                    </svg>
                  </div>
                  <h3>Sentença Judicial</h3>
                  <p>Decisão favorável transitada em julgado</p>
                </div>
                <div className="illustration-arrow">→</div>
                <div className="illustration-card">
                  <div className="illustration-icon">
                    <svg width="80" height="80" viewBox="0 0 24 24" fill="currentColor">
                      <path d="M14 2H6c-1.1 0-1.99.9-1.99 2L4 20c0 1.1.89 2 1.99 2H18c1.1 0 2-.9 2-2V8l-6-6z"/>
                    </svg>
                  </div>
                  <h3>Precatório</h3>
                  <p>Ordem de pagamento emitida</p>
                </div>
                <div className="illustration-arrow">→</div>
                <div className="illustration-card">
                  <div className="illustration-icon">
                    <svg width="80" height="80" viewBox="0 0 24 24" fill="currentColor">
                      <path d="M11.8 10.9c-2.27-.59-3-1.2-3-2.15 0-1.09 1.01-1.85 2.7-1.85 1.78 0 2.44.85 2.5 2.1h2.21c-.07-1.72-1.12-3.3-3.21-3.81V3h-3v2.16c-1.94.42-3.5 1.68-3.5 3.61 0 2.31 1.91 3.46 4.7 4.13 2.5.6 3 1.48 3 2.41 0 .69-.49 1.79-2.7 1.79-2.06 0-2.87-.92-2.98-2.1h-2.2c.12 2.19 1.76 3.42 3.68 3.83V21h3v-2.15c1.95-.37 3.5-1.5 3.5-3.55 0-2.84-2.43-3.81-4.7-4.4z"/>
                    </svg>
                  </div>
                  <h3>Pagamento</h3>
                  <p>Credor recebe o valor devido</p>
                </div>
              </div>
            </div>
          </div>
        </section>

        {/* Types Section */}
        <section className="types-section">
          <div className="container">
            <div className="section-header">
              <h2 className="section-title white-title">Tipos de Precatórios</h2>
            </div>

            <div className="types-grid">
              <div className="type-card">
                <h3>Precatórios Comuns</h3>
                <p>Valores acima de 60 salários mínimos. Seguem ordem cronológica de apresentação e são pagos até 31 de dezembro do ano seguinte.</p>
              </div>

              <div className="type-card">
                <h3>RPVs (Requisições de Pequeno Valor)</h3>
                <p>Valores até 60 salários mínimos. Têm prioridade e prazo de pagamento mais curto (geralmente 60 dias).</p>
              </div>

              <div className="type-card">
                <h3>Precatórios Alimentares</h3>
                <p>Relacionados a salários, pensões, indenizações por acidente de trabalho ou danos morais. Têm preferência no pagamento.</p>
              </div>

              <div className="type-card">
                <h3>Precatórios Não Alimentares</h3>
                <p>Desapropriações, indenizações patrimoniais e outras dívidas não alimentares.</p>
              </div>

              <div className="type-card">
                <h3>Precatórios Preferenciais</h3>
                <p>Idosos acima de 60 anos, portadores de doenças graves ou pessoas com deficiência têm prioridade absoluta.</p>
              </div>

              <div className="type-card">
                <h3>Precatórios Federais, Estaduais e Municipais</h3>
                <p>Classificados conforme o ente devedor (União, Estado ou Município).</p>
              </div>
            </div>
          </div>
        </section>

        {/* Timeline Section */}
        <section className="timeline-section">
          <div className="container">
            <div className="section-header">
              <h2 className="section-title">Linha do Tempo de um Precatório</h2>
            </div>

            <div className="timeline-container">
              <div className="timeline-item">
                <div className="timeline-marker">1</div>
                <div className="timeline-content">
                  <h3>Sentença Transitada em Julgado</h3>
                  <p>O processo judicial é finalizado com decisão favorável ao credor</p>
                  <span className="timeline-duration">Prazo variável</span>
                </div>
              </div>

              <div className="timeline-item">
                <div className="timeline-marker">2</div>
                <div className="timeline-content">
                  <h3>Cálculo do Valor</h3>
                  <p>O juiz determina o valor exato a ser pago, incluindo correções e juros</p>
                  <span className="timeline-duration">3-12 meses</span>
                </div>
              </div>

              <div className="timeline-item">
                <div className="timeline-marker">3</div>
                <div className="timeline-content">
                  <h3>Expedição do Precatório</h3>
                  <p>O tribunal expede a requisição de pagamento ao ente devedor</p>
                  <span className="timeline-duration">6-18 meses</span>
                </div>
              </div>

              <div className="timeline-item">
                <div className="timeline-marker">4</div>
                <div className="timeline-content">
                  <h3>Inclusão no Orçamento</h3>
                  <p>O precatório é incluído na lei orçamentária do ano seguinte</p>
                  <span className="timeline-duration">1 ano</span>
                </div>
              </div>

              <div className="timeline-item timeline-item-highlight">
                <div className="timeline-marker">5</div>
                <div className="timeline-content">
                  <h3>Pagamento</h3>
                  <p>O credor finalmente recebe o valor devido</p>
                  <span className="timeline-duration">5-15+ anos do início</span>
                </div>
              </div>
            </div>

            <div className="timeline-alternative">
              <div className="alternative-badge">Alternativa MICA Capital</div>
              <h3>Receba em até 5 dias com a MICA Capital</h3>
              <p>Nossa IA analisa seu precatório e gera uma proposta justa em minutos. Você recebe o dinheiro na conta em até 5 dias.</p>
              <button className="btn btn-primary btn-large" onClick={handleCTAClick}>
                Vender Meu Precatório Agora
              </button>
            </div>
          </div>
        </section>

        {/* Why Sell Section */}
        <section className="why-sell-section">
          <div className="container">
            <div className="section-header">
              <h2 className="section-title">Por Que Vender Seu Precatório?</h2>
            </div>

            <div className="why-sell-grid">
              <div className="why-sell-card">
                <div className="why-sell-icon">
                  <svg width="60" height="60" viewBox="0 0 24 24" fill="currentColor">
                    <path d="M11.99 2C6.47 2 2 6.48 2 12s4.47 10 9.99 10C17.52 22 22 17.52 22 12S17.52 2 11.99 2zM12 20c-4.42 0-8-3.58-8-8s3.58-8 8-8 8 3.58 8 8-3.58 8-8 8zm.5-13H11v6l5.25 3.15.75-1.23-4.5-2.67z"/>
                  </svg>
                </div>
                <h3>Liquidez Imediata</h3>
                <p>Ao invés de esperar anos, receba o dinheiro em poucos dias e use como quiser.</p>
              </div>

              <div className="why-sell-card">
                <div className="why-sell-icon">
                  <svg width="60" height="60" viewBox="0 0 24 24" fill="currentColor">
                    <path d="M12 2L2 7v10c0 5.55 3.84 10.74 9 12 5.16-1.26 9-6.45 9-12V7l-10-5zm0 10.99h7c-.53 4.12-3.28 7.79-7 8.94V12H5V7.89l7-3.11v8.2z"/>
                  </svg>
                </div>
                <h3>Elimine Incertezas</h3>
                <p>Evite riscos de calotes, parcelamentos forçados ou mudanças nas regras de pagamento.</p>
              </div>

              <div className="why-sell-card">
                <div className="why-sell-icon">
                  <svg width="60" height="60" viewBox="0 0 24 24" fill="currentColor">
                    <path d="M19 3H5c-1.11 0-2 .9-2 2v14c0 1.1.89 2 2 2h14c1.1 0 2-.9 2-2V5c0-1.1-.9-2-2-2zm-5 14H7v-2h7v2zm3-4H7v-2h10v2zm0-4H7V7h10v2z"/>
                  </svg>
                </div>
                <h3>Planeje Seu Futuro</h3>
                <p>Use o dinheiro para investir, quitar dívidas, empreender ou realizar sonhos.</p>
              </div>

              <div className="why-sell-card">
                <div className="why-sell-icon">
                  <svg width="60" height="60" viewBox="0 0 24 24" fill="currentColor">
                    <path d="M12 2C6.48 2 2 6.48 2 12s4.48 10 10 10 10-4.48 10-10S17.52 2 12 2zm-2 15l-5-5 1.41-1.41L10 14.17l7.59-7.59L19 8l-9 9z"/>
                  </svg>
                </div>
                <h3>Processo Simples</h3>
                <p>Com a MICA Capital, todo o processo é 100% digital, rápido e sem burocracia.</p>
              </div>
            </div>
          </div>
        </section>

        {/* FAQ Section */}
        <section className="faq-section">
          <div className="container">
            <div className="section-header">
              <h2 className="section-title">Perguntas Frequentes</h2>
            </div>

            <div className="faq-container">
              {faqs.map((faq, index) => (
                <div key={index} className={`faq-item ${activeFAQ === index ? 'active' : ''}`}>
                  <button className="faq-question" onClick={() => toggleFAQ(index)}>
                    <span>{faq.question}</span>
                    <svg width="24" height="24" viewBox="0 0 24 24" fill="currentColor" className="faq-icon">
                      <path d={activeFAQ === index ? "M19 13H5v-2h14v2z" : "M19 13h-6v6h-2v-6H5v-2h6V5h2v6h6v2z"} />
                    </svg>
                  </button>
                  <div className="faq-answer">
                    <p>{faq.answer}</p>
                  </div>
                </div>
              ))}
            </div>
          </div>
        </section>

        {/* CTA Section */}
        <section className="cta-section">
          <div className="container">
            <div className="cta-content">
              <h2 className="cta-title">Pronto para Vender Seu Precatório?</h2>
              <p className="cta-subtitle">
                Cadastre seu precatório agora e receba uma proposta em minutos. Dinheiro na conta em até 5 dias!
              </p>
              <button className="btn btn-primary btn-large" onClick={handleCTAClick}>
                Cadastrar Meu Precatório
              </button>
            </div>
          </div>
        </section>
      </main>
    </div>
  );
};

export default Precatorios;
